// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__YOJm2","label":"Completed_label__26xss"};